import React from 'react';
import theme from '@shared/utils/themeColors';
import { StudyPlan } from '../types/study-plan.types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './StudyPlanContent.css'; // Importamos un archivo CSS externo

interface StudyPlanContentProps {
  studyPlan: StudyPlan;
}

/**
 * Component to display the study plan content
 */
const StudyPlanContent: React.FC<StudyPlanContentProps> = ({ studyPlan }) => {
  return (
    <div className={`p-4 sm:p-6 lg:p-8 ${theme.bg.primary} rounded-lg shadow`}>
      {/* Header with Bee Assistant */}
      <div className="flex items-center mb-6">
        <div className="flex-shrink-0 mr-4">
          <img
            src="/assets/images/avatar.png"
            alt="Bee Assistant"
            className="w-16 h-16 rounded-full"
          />
        </div>
        <div>
          <h2 className={`text-xl font-bold ${theme.text.primary}`}>
            Bee Assistant
          </h2>
          <p className={`${theme.text.muted}`}>
            Your Personalized Learning Journey
          </p>
        </div>
      </div>

      {/* Study Plan Content */}
      <div className="prose prose-sm sm:prose lg:prose-lg max-w-none markdown-content dark:prose-invert">
        {studyPlan.content ? (
          <ReactMarkdown 
            remarkPlugins={[remarkGfm]}
            components={{
              // Add responsive table support
              table: ({ node, ...props }) => (
                <div className="overflow-x-auto">
                  <table {...props} className="min-w-full" />
                </div>
              ),
            }}
          >
            {studyPlan.content}
          </ReactMarkdown>
        ) : (
          <div className="text-center py-8">
            <p className={`${theme.text.muted} text-lg`}>
              No study plan content available. Please generate a new study plan.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudyPlanContent;